/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LeistungstraegerInputs */

const de__field_leistungstraeger = /** @type {(inputs: _Field_LeistungstraegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungsträger`)
};

/**

* @param {_Field_LeistungstraegerInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_leistungstraeger = /** @type {((inputs?: _Field_LeistungstraegerInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LeistungstraegerInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_leistungstraeger(inputs)
});